import { AssetTypeService as OvermapAssetTypeService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class AssetTypeService extends OvermapAssetTypeService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
